export default __webpack_public_path__ + "static/media/icone_facebook-fill.724e0482.png";